import { FC } from "react"

import Dialog from "components/common/dialog/dialog"
import { useTranslation } from "react-i18next"

interface IProps {
  open: boolean
  onClose: () => void
  onAccept: () => void
}

const DialogClose: FC<IProps> = ({ open, onClose, onAccept }) => {
  const { t } = useTranslation()

  return (
    <Dialog
      titleText={t("students.areYoutSure")}
      descriptionText={t("students.enteredInformationWillBeLost")}
      open={open}
      onClose={onClose}
      actionAcceptText={t("close")}
      onActionButtonClick={onAccept}
    />
  )
}

export default DialogClose
